import { render } from "./PlanIndicator.vue?vue&type=template&id=56bf8d1e&scoped=true"
import script from "./PlanIndicator.vue?vue&type=script&lang=js"
export * from "./PlanIndicator.vue?vue&type=script&lang=js"

import "./PlanIndicator.vue?vue&type=style&index=0&id=56bf8d1e&scoped=true&lang=css"

import exportComponent from "/var/www/html/nchsaet-11/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-56bf8d1e"]])

export default __exports__